module.exports = __webpack_public_path__ + "img/rob.7ef9f0bc.png";